import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { FaCrown, FaTrophy, FaHeart } from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';

/**
 * Bannière de promotion Premium affichée uniquement aux utilisateurs Free.
 * variant="compact"  → strip horizontal fin (Home)
 * variant="default"  → carte medium avec avantages (Leaderboard, Shop)
 */
function PremiumBanner({ variant = 'default', className = '' }) {
  const navigate = useNavigate();
  const { user } = useAuth();

  if (user?.plan === 'premium') return null;

  if (variant === 'compact') {
    return (
      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
        className={className}
      >
        <button
          onClick={() => navigate('/shop')}
          className="w-full flex items-center justify-between px-4 py-2.5 rounded-xl relative overflow-hidden"
          style={{
            background: 'linear-gradient(135deg, rgba(240,180,41,0.22) 0%, rgba(240,180,41,0.10) 100%)',
            border: '1px solid rgba(240,180,41,0.50)',
            boxShadow: '0 0 12px rgba(240,180,41,0.12)',
          }}
        >
          <div className="flex items-center gap-2">
            <FaCrown size={13} className="text-qfl-gold flex-shrink-0" />
            <span
              className="text-white font-bold text-xs uppercase tracking-wider"
              style={{ fontFamily: "'Rajdhani', sans-serif" }}
            >
              Premium · Vies illimitées + Tournois + Badge couronne
            </span>
          </div>
          <span
            className="text-qfl-gold text-xs font-black flex-shrink-0 ml-2 whitespace-nowrap"
            style={{ fontFamily: "'Rajdhani', sans-serif" }}
          >
            1 000 FCFA →
          </span>
        </button>
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3 }}
      className={className}
    >
      <button
        onClick={() => navigate('/shop')}
        className="w-full flex flex-col items-center gap-3 px-4 py-4 rounded-xl relative overflow-hidden text-left"
        style={{
          background: 'linear-gradient(135deg, #1c3d28 0%, #0d2b1a 100%)',
          border: '1px solid rgba(240,180,41,0.35)',
          boxShadow: '0 0 24px rgba(240,180,41,0.08)',
        }}
      >
        <div className="absolute inset-0 shimmer opacity-15 pointer-events-none" />

        {/* Titre */}
        <div className="flex items-center gap-2 w-full justify-center">
          <FaCrown size={15} className="text-qfl-gold" />
          <span
            className="text-qfl-gold font-black text-sm uppercase tracking-widest"
            style={{ fontFamily: "'Rajdhani', sans-serif" }}
          >
            PASSE PREMIUM
          </span>
          <FaCrown size={15} className="text-qfl-gold" />
        </div>

        {/* Avantages */}
        <div className="flex items-center justify-center gap-5 flex-wrap">
          <span className="flex items-center gap-1.5 text-xs text-white/70">
            <FaHeart size={11} className="text-red-400" />
            Vies illimitées
          </span>
          <span className="flex items-center gap-1.5 text-xs text-white/70">
            <FaTrophy size={11} className="text-qfl-gold" />
            Tournois exclusifs
          </span>
          <span className="flex items-center gap-1.5 text-xs text-white/70">
            <FaCrown size={11} className="text-qfl-gold" />
            Badge couronne
          </span>
        </div>

        {/* CTA */}
        <div
          className="px-5 py-1.5 rounded-full text-xs font-black uppercase tracking-widest"
          style={{
            background: 'linear-gradient(135deg, #f0b429, #c97d08)',
            color: '#0d2b1a',
            fontFamily: "'Rajdhani', sans-serif",
          }}
        >
          DÉBLOQUER — 1 000 FCFA/MOIS
        </div>
      </button>
    </motion.div>
  );
}

export default PremiumBanner;
